export default "/images/vendor/flag-icon-css/flags/4x3/de.svg?7e82f4c71df5fc78abbb54a6f82ed299";